import api from '../api'
import { bus } from '../main'

/**********************************************************************
 * *Actions for crud's
 * !do not modify, actions used by all components
 **********************************************************************/


export const get = ({ commit }, request) => {    
    return new Promise((resolve, reject) => {        
        bus.$emit('loading', true);        
        api.get(request, (response) => {
            if (request.mutation)
                commit(request.mutation, response.data)
            resolve(response.data)
            setTimeout(() => {                  
                bus.$emit('loading', false);
            }, 500);
            
        }, (error) => {
            reject(error)
            bus.$emit('loading', false);
        })
    });
}

export const post = ({ commit }, request) => {
    return new Promise((resolve, reject) => {
        bus.$emit('loading', true)

        api.post(request, (response) => {
            if (request.mutation)
                commit(request.mutation, response.data)
            resolve(response.data)
            if (bus){
                setTimeout(() => {                  
                    bus.$emit('loading', false);
                }, 500);
            }
        }, (error) => {
            /* reject(error.data.errors) */
            reject(error)
            if (bus) bus.$emit('loading', false)
        })
    });
}

